import { useState, useEffect } from "react"
import { fetchFilingMetrics, FilingMetrics } from "../lib/api/metrics"

interface UseFilingMetricsReturn {
  metrics: FilingMetrics | null
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

/**
 * Hook to fetch filing metrics for the dashboard
 */
export function useFilingMetrics(): UseFilingMetricsReturn {
  const [metrics, setMetrics] = useState<FilingMetrics | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const loadMetrics = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await fetchFilingMetrics()
      setMetrics(data)
    } catch (err) {
      console.error("[useFilingMetrics] Error fetching metrics:", err)
      setError(
        err instanceof Error ? err.message : "Failed to load metrics"
      )
    } finally {
      setLoading(false)
    }
  }

  const refetch = async () => {
    await loadMetrics()
  }

  useEffect(() => {
    loadMetrics()
  }, [])

  return {
    metrics,
    loading,
    error,
    refetch,
  }
}



